import { render, staticRenderFns } from "./multiple-chip-select.vue?vue&type=template&id=3cb2bb0e"
import script from "./multiple-chip-select.vue?vue&type=script&lang=js"
export * from "./multiple-chip-select.vue?vue&type=script&lang=js"
import style0 from "./multiple-chip-select.vue?vue&type=style&index=0&id=3cb2bb0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports